export default __webpack_public_path__ + "static/media/gallery - potions_03.09795deb.jpg";